var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.location && _vm.location.length > 0)?_c('ion-label',{attrs:{"slot":"end"},slot:"end"},[_c('ion-img',{attrs:{"src":_vm.src},on:{"ionError":_vm.brokeImage}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }